/**
 * @description 全局挂载
 */
import SupportShortCutModal from 'Src/components/common/support-shortcut-modal.vue'
export default {
  install: vue => {
    vue.component('support-shortcut-modal', SupportShortCutModal)
  }
}
